import { useContext } from "react";
import { defaultHeaderHeight } from "src/settings/config";
import dashboardContext from "src/context/dashboardContext";

const style = {
    backdropFilter: "blur(3px)",
    WebkitBackdropFilter: "blur(3px)",
    top: `${defaultHeaderHeight}px`,
};
export default function SidebarBackdrop({ state }) {
    const {setSidebarState} = useContext(dashboardContext)
    return (
        
        <div
            className={`${state ? "visible" : "invisible"} fixed inset-0 z-10 bg-black bg-opacity-20 lg:hidden`}
            style={style}
            onClick={()=>setSidebarState(0)}
        ></div>

    )
}